import React, { useState, useEffect, useRef } from "react";
import "./Blog.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { motion } from "framer-motion";
import Adelaidebanner from "../Assets/Blog/about-us-banner-img.png";
import blogBanner from "../Assets/Blog/blog-banner-img.jpg";
import { Link } from "react-router-dom";
import Google from "../Assets/Google.png";
import GoogleG from "../Assets/Google-G.png";
import verified from "../Assets/ti-verified.svg fill.png";

import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";
import { FaChevronRight, FaChevronLeft } from "react-icons/fa";

const Blog = () => {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("testimonials").then((res) => {
      setTestimonials(res.data.testimonials);
    });
  }, []);

  const [scrollIndex, setScrollIndex] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);
  const scrollRef = useRef();
  const CARD_WIDTH = 300 + 16; // width + margin

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      if (width < 576) {
        setVisibleCards(1);
      } else if (width < 768) {
        setVisibleCards(1);
      } else if (width < 992) {
        setVisibleCards(2);
      } else {
        setVisibleCards(3);
      }
    };

    updateVisibleCards();
    window.addEventListener("resize", updateVisibleCards);
    return () => window.removeEventListener("resize", updateVisibleCards);
  }, []);

  const scroll = (direction) => {
    const maxIndex = Math.ceil(testimonials.length / visibleCards) - 1;
    let newIndex = scrollIndex;

    if (direction === "left") {
      newIndex = Math.max(0, scrollIndex - 1);
    } else if (direction === "right") {
      newIndex = Math.min(maxIndex, scrollIndex + 1);
    }

    setScrollIndex(newIndex);

    if (scrollRef.current) {
      scrollRef.current.style.transform = `translateX(-${
        newIndex * CARD_WIDTH * visibleCards
      }px)`;
    }
  };

  const renderStars = (count) =>
    Array.from({ length: count }, (_, i) => (
      <b key={i} className="fa-solid fa-star" style={{ color: "gold" }}>
        ★
      </b>
    ));

  const [reviewCount, setReviewCount] = useState(null);

  useEffect(() => {
    api
      .get("google-review-count")
      .then((res) => {
        if (res.data) {
          setReviewCount(res.data.review_count);
        }
      })
      .catch((err) => {
        console.error("Error fetching Google Review Count:", err);
      });
  }, []);

  const [heroData, setHeroData] = useState(null);

  useEffect(() => {
    api
      .get("bloghero")
      .then((res) => {
        setHeroData(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch blog hero data:", err);
      });
  }, []);

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    api
      .get("blogs") // Update base URL if needed
      .then((res) => setBlogs(res.data))
      .catch((err) => console.error(err));
  }, []);

  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 5;

  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = blogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(blogs.length / blogsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <Header />

      <section
        className="hero-section py-24 text-white text-center relative"
        style={{
          background: `url(${BASE_URL}${heroData?.background_image}) center/cover no-repeat`,
          position: "relative",
          height: "100vh",
        }}
      >
        <div
          className="container mx-auto px-4 relative z-10"
          style={{ marginTop: "150px" }}
        >
          <motion.h1
            className="text-4xl md:text-5xl lg:text-6xl fw-bold mb-4 mt-5"
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            {heroData?.heading}
          </motion.h1>

          <motion.p
            className="text-lg fw-bold"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            {heroData?.breadcrumb}
          </motion.p>
        </div>

        {/* Optional Overlay */}
        <div className="absolute inset-0 bg-black opacity-40 z-0"></div>
      </section>

      <div>
        {currentBlogs.map((blog) => (
          <section key={blog.id} className="py-5 bg-light">
            <div className="container">
              <div className="row align-items-center gy-5">
                {/* Image Section */}
                <div className="col-lg-6">
                  <div className="blog-left position-relative overflow-hidden rounded-4 shadow blog-img-wrapper">
                    <img
                      src={`${PUBLIC_BASE_URL}${blog.image}`}
                      alt={blog.title}
                      className="img-fluid w-100 rounded-4 object-fit-cover"
                      style={{ minHeight: "200px" }}
                    />
                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-25 rounded-4"></div>
                    <div className="position-absolute top-0 start-0 m-3 bg-white text-primary px-3 py-2 rounded-3 shadow-sm text-center fw-bold" >
                      <div className="fs-3">
                        {new Date(blog.publish_date).getDate()}
                      </div>
                      <div className="text-uppercase fs-6">
                        {new Date(blog.publish_date).toLocaleString("default", {
                          month: "short",
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Content Section */}
                <div className="col-lg-6 " >
                  <div className="blog-right p-4 bg-white bg-opacity-75 shadow-lg rounded-4 animate-fade" >
                    <h2 className="h4 text-primary fw-bold mb-3">
                      {blog.title}
                    </h2>
                    <p
  className="text-secondary mb-4"
  dangerouslySetInnerHTML={{
    __html:
      blog.description.length > 500
        ? blog.description.substring(0, 500) + "…"
        : blog.description,
  }}
></p>

                    <Link
                      to={`/blog-details/${blog.slug}`}
                      className="btn btn-outline-primary fw-bold text-uppercase px-4 py-2"
                      style={{ borderRadius: "30px" }}
                    >
                      Read More
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ))}
      </div>

      <nav aria-label="Page navigation">
        <ul className="pagination justify-content-center gap-2">
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <button
              className="page-link pagination-link"
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
            >
              « Previous
            </button>
          </li>

          {Array.from({ length: totalPages }, (_, index) => index + 1).map(
            (page) => (
              <li
                className={`page-item ${currentPage === page ? "active" : ""}`}
                key={page}
              >
                <button
                  className="page-link pagination-link"
                  onClick={() => paginate(page)}
                >
                  {page}
                </button>
              </li>
            )
          )}

          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <button
              className="page-link pagination-link"
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
            >
              Next »
            </button>
          </li>
        </ul>
      </nav>

      <section className="testimonials-section">
        <div className="container">
          <div className="section-header text-center mb-4">
            <p className="subheading">— Testimonials</p>
            <h2>Client Testimonies: Experience with Our Cleaners</h2>
          </div>

          <div className="row">
            {/* Left Summary */}
            <div className="col-lg-3 col-md-4 mb-4 text-center review-summary">
              <p className="rating-label m-0 fw-bold fs-5">EXCELLENT</p>
              <div className="stars">{renderStars(5)}</div>
              <p>
                Based on{" "}
                <strong>{reviewCount !== null ? reviewCount : "..."}</strong>{" "}
                reviews
              </p>
              <img
                src={Google}
                alt="Google"
                style={{ width: "100px", marginTop: "-10px" }}
              />
            </div>

            {/* Testimonials Scrollable */}
            <div className="col-lg-9 col-md-8 position-relative testimonial-scroll-wrapper">
              <div className="testimonial-scroll d-flex" ref={scrollRef}>
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="testimonial-card p-3 mx-2 bg-white rounded shadow"
                  >
                    <div className="card-header d-flex align-items-center mb-2">
                      {item.avatar ? (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.avatar}`}
                          className="avatar-img me-2 rounded-circle"
                          alt={item.name}
                          style={{ width: 40, height: 40 }}
                        />
                      ) : (
                        <div className="avatar me-2">
                          {item.name?.charAt(0)}
                        </div>
                      )}
                      <div>
                        <h5 className="mb-0">{item.name}</h5>
                        <small>{item.date}</small>
                      </div>
                      <img
                        src={`${PUBLIC_BASE_URL}${item.platform}`}
                        alt="Platform"
                        style={{ width: 16, marginLeft: "auto" }}
                      />
                    </div>

                    <div className="rating mb-2">
                      {renderStars(item.rating)}
                      {item.verified && (
                        <img
                          src={`${PUBLIC_BASE_URL}${item.verified}`}
                          alt="verified"
                          style={{
                            width: 16,
                            marginLeft: "6px",
                            verticalAlign: "middle",
                          }}
                        />
                      )}
                    </div>

                    <p className="comment-truncate m-0">{item.comment}</p>
                  </div>
                ))}
              </div>

              {/* Arrow Controls */}
              <div className="d-flex justify-content-center gap-2 scroll-controls">
                <button
                  onClick={() => scroll("left")}
                  className="scroll-arrow left-arrow"
                >
                  <FaChevronLeft />
                </button>
                <button
                  onClick={() => scroll("right")}
                  className="scroll-arrow right-arrow"
                >
                  <FaChevronRight />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Blog;
